document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const menu = document.querySelector('.ac-mobile-menu[open]');
  if (!menu) return;
  if (!menu.contains(event.target)) menu.removeAttribute('open');
});

document.addEventListener('keyup', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.ac-mobile-menu[open]');
  if (menu) menu.removeAttribute('open');
});
